// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'hubspot.bender' or its corresp... Remove this comment to see the full error message
import benderDeps from 'hubspot.bender';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { stringify } from 'hub-http/helpers/params';
import I18n from 'I18n';
import { PREVIEW_PAGES } from 'knowledge-content-ui/constants/TemplateEditorConstants';
const I18N_PREFIX = 'knowledgeContentUI.templateEditor.sidebar';
const useLocal = enviro.getShort('knowledge-content-ui') === 'local' || !enviro.deployed('knowledge-content-ui');
const branchPreviewBuild = benderDeps.staticDomain.includes('dynamic.hsappstatic.net') ? benderDeps.staticDomain.split(/b-|\./g)[1] : null;
const BASE_PREVIEW_PARAMS = {
  portalId: PortalIdParser.get(),
  themePreviewerUI: true,
  benderPackage: 'knowledge-content-embed',
  staticVersion: benderDeps.depVersions['knowledge-content-embed'],
  scriptPath: 'bundles/embed.js',
  cssPath: 'sass/embed.css',
  localAssets: useLocal,
  appDomain: document.location.origin,
  branchPreviewBuild
};
const getBufferParams = ({
  useBuffer
}) => {
  return {
    preview_theme: useBuffer,
    buffer_theme: useBuffer,
    hard_knowledge_base: !useBuffer
  };
};
function getPreviewUrl(params, previewDomain) {
  return `https://${previewDomain}/_hcms/preview/template/multi?${stringify(params)}`;
}
export function getTemplateEditorPreviewUrl(previewPage, templatePaths, language, previewDomain, knowledgeBaseId) {
  const params = Object.assign({}, BASE_PREVIEW_PARAMS, getBufferParams({
    useBuffer: true
  }), {
    path: templatePaths[previewPage],
    sampleKnowledgeArticle: previewPage === PREVIEW_PAGES.ARTICLE_PAGE,
    sampleKnowledgeCategory: previewPage === PREVIEW_PAGES.CATEGORY_PAGE,
    language,
    content_group_id: knowledgeBaseId
  });
  return getPreviewUrl(params, previewDomain);
}
export function getTranslateTemplatePreviewUrl(indexTemplatePath, language, knowledgeBaseId) {
  const params = Object.assign({}, BASE_PREVIEW_PARAMS, getBufferParams({
    useBuffer: false
  }), {
    path: indexTemplatePath,
    kbuiMode: 'translate-template',
    language,
    content_group_id: knowledgeBaseId
  });
  return getPreviewUrl(params, window.hsPreviewDomain);
}
export function getTemplateEditorDropdownPages() {
  return [{
    text: I18n.text(`${I18N_PREFIX}.navItems.home-page.title`),
    value: PREVIEW_PAGES.HOME_PAGE
  }, {
    text: I18n.text(`${I18N_PREFIX}.navItems.article-page.title`),
    value: PREVIEW_PAGES.ARTICLE_PAGE
  }, {
    text: I18n.text(`${I18N_PREFIX}.navItems.category-page.title`),
    value: PREVIEW_PAGES.CATEGORY_PAGE
  }];
}